import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ApplyLabelDialogData } from '@app/shared/components/dialogs/apply-label-dialog/apply-label-dialog.data';

@Component({
    selector : 'apply-label-dialog',
    template: require('./apply-label-dialog.component.html'),
    styles: [require('./apply-label-dialog.component.scss')]
})
export class ApplyLabelDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ApplyLabelDialogData) {
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/apply-label-dialog/apply-label-dialog.component.ts